import React, { useState } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import TextareaAutosize from "@mui/material/TextareaAutosize";
import ReAuthDialog from "../auth/ReAuthDialog";
import Loader from "../Loader";
import {
    extractPublicKeyFromPrivateKey,
    extractPublicKeyFromCertificate,
} from "../../services/crypto";
import { downloadCertificate } from "../../api/requests";

const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 700,
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
    height: 400,
};

const KeyModal = ({
    open,
    setOpen,
    row,
    setDataState,
    callback,
    isUpdate = null,
}) => {
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const [keyString, setKeyString] = useState("");

    const [openKeyReauth, setOpenKeyReauth] = useState(false);

    const [isLoading, setIsLoading] = useState(false);

    const [isValidKey, setIsValidKey] = useState(true);

    const showFile = async (e) => {
        e.preventDefault();
        const reader = new FileReader();
        reader.onload = async (e) => {
            const text = e.target.result;
            console.log(text);
            setKeyString(text);
        };
        reader.readAsText(e.target.files[0]);
    };

    const validatePrivateKey = async () => {
        try {
            const extractedPublicKey =
                extractPublicKeyFromPrivateKey(keyString);
            const downloadedCertificate = await downloadCertificate(
                row.firestoreId
            );

            const actualPublicKey = extractPublicKeyFromCertificate(
                downloadedCertificate.pems.certificate
            );

            if (!extractedPublicKey || !actualPublicKey) {
                return false;
            }
            return extractedPublicKey === actualPublicKey;
        } catch (error) {
            return false;
        }
    };

    return (
        <div>
            <Button onClick={handleOpen}>Open modal</Button>

            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <>
                    {isLoading && <Loader />}
                    <div
                        style={{ visibility: isLoading ? "hidden" : "visible" }}
                    >
                        <ReAuthDialog
                            open={openKeyReauth}
                            setOpen={setOpenKeyReauth}
                            handler={async () => {
                                if (!(await validatePrivateKey())) {
                                    setIsValidKey(false);
                                    setOpenKeyReauth(false);
                                    return;
                                }
                                setIsLoading(true);
                                console.log("key reauth handler");
                                const res = await callback(
                                    row.firestoreId,
                                    `${keyString}`
                                );
                                if (res) {
                                    setDataState((prev) => {
                                        return prev.map((cert) => {
                                            if (
                                                cert.firestoreId ===
                                                row.firestoreId
                                            ) {
                                                return {
                                                    ...cert,
                                                    hasKey: true,
                                                };
                                            }
                                            return cert;
                                        });
                                    });
                                    setKeyString("");
                                    handleClose();
                                }
                                setIsLoading(false);
                            }}
                            dialogSuffix={isUpdate ? "-05" : "-02"}
                            isLoading={isLoading}
                        />
                        <Box sx={style}>
                            <Typography
                                id="modal-modal-title"
                                variant="h6"
                                component="h2"
                            >
                                Upload a private key
                            </Typography>
                            <TextareaAutosize
                                aria-label="minimum height"
                                minRows={10}
                                maxRows={15}
                                placeholder="insert private key"
                                style={{ width: 400 }}
                                value={keyString}
                                onChange={(e) => {
                                    setKeyString(e.target.value);
                                }}
                            />
                            <div>
                                <input
                                    type="file"
                                    onChange={(e) => showFile(e)}
                                />
                            </div>
                            <div>
                                <Button onClick={handleClose}>Cancel</Button>
                                <Button
                                    onClick={async () => {
                                        setOpenKeyReauth(true);
                                    }}
                                >
                                    Upload
                                </Button>
                            </div>
                            <div
                                style={{ color: isValidKey ? "green" : "red" }}
                            >
                                {isValidKey ? "" : "private key not valid"}
                            </div>
                        </Box>
                    </div>
                </>
            </Modal>
        </div>
    );
};

export default KeyModal;
